"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _reactPlayerLoader = require("@brightcove/react-player-loader");

var _reactPlayerLoader2 = _interopRequireDefault(_reactPlayerLoader);

var _tracking_utility = require("../../../packages/common-utilities/src/tracking_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundVideoComponent = function (_React$Component) {
  _inherits(FundVideoComponent, _React$Component);

  function FundVideoComponent(props) {
    _classCallCheck(this, FundVideoComponent);

    var _this = _possibleConstructorReturn(this, (FundVideoComponent.__proto__ || Object.getPrototypeOf(FundVideoComponent)).call(this, props));

    _this.loadBrightcoveVideo = _this.loadBrightcoveVideo.bind(_this);
    _this.videoPlayerEvent = _this.videoPlayerEvent.bind(_this);
    _this.datalayerContainsPercentage = _this.datalayerContainsPercentage.bind(_this);
    _this.fundVideoPlayerRef = _react2.default.createRef();
    return _this;
  }

  _createClass(FundVideoComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.window.addEventListener("resize", this.loadBrightcoveVideo);
      this.createBrightcoveScriptOnlyOnce();
    }
  }, {
    key: "createBrightcoveScriptOnlyOnce",
    value: function createBrightcoveScriptOnlyOnce() {
      var _this2 = this;

      if ((0, _ramda.isNil)(document.getElementById("funds-brightcove-player-id"))) {
        var script = document.createElement("script");
        script.src = "//players.brightcove.net/" + this.props.fundVideo.mediaPlayerId + "/" + this.props.fundVideo.mediaPlayerKey + "_default/index.min.js";
        script.id = "funds-brightcove-player-id";
        document.createStyleSheet = false;
        document.body.appendChild(script);
        script.onload = function () {
          _this2.loadBrightcoveVideo();
        };
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.fundVideoPlayerRef.current && !(0, _ramda.isNil)(this.fundVideoPlayerRef.current) && this.fundVideoPlayerRef.current.children.length < 1) {
        this.loadBrightcoveVideo();
      }
    }
  }, {
    key: "loadBrightcoveVideo",
    value: function loadBrightcoveVideo() {
      var _this3 = this;

      var brightcoveFunctionReady = typeof window.bc === 'function' && !(0, _ramda.isNil)(this.fundVideoPlayerRef.current);
      if (brightcoveFunctionReady) {
        this.callBrightcoveFunction();
      } else {
        window.setTimeout(function () {
          if (brightcoveFunctionReady) {
            _this3.callBrightcoveFunction();
          }
        }, 1000);
      }
    }
  }, {
    key: "callBrightcoveFunction",
    value: function callBrightcoveFunction() {
      try {
        window.bc(this.fundVideoPlayerRef.current);
      } catch (e) {
        /* eslint-disable*/
        console.error(e);
        /* eslint-enable*/
      }
    }
  }, {
    key: "datalayerContainsPercentage",
    value: function datalayerContainsPercentage(type, eventAction, eventLabel) {
      return window.dataLayer && window.dataLayer.filter(function (d) {
        return d.eventCategory === _tracking_utility.TrackingUtility.getEventCategory(type) && d.eventAction === eventAction && d.eventLabel === eventLabel;
      }).length > 0;
    }
  }, {
    key: "videoPlayerEvent",
    value: function videoPlayerEvent(currentTime, videoDuration, videoTitle) {
      var BRIGHTCOVE_VIDEO = "brightcove_video";
      if (currentTime && videoDuration) {
        var percentageWatched = Math.floor(currentTime / videoDuration * 100);
        var roundedPercentage = 0;
        if (percentageWatched >= 100) {
          roundedPercentage = 100;
        } else if (percentageWatched >= 75) {
          roundedPercentage = 75;
        } else if (percentageWatched >= 50) {
          roundedPercentage = 50;
        } else if (percentageWatched >= 25) {
          roundedPercentage = 25;
        }

        var eventAction = 'percent played | ' + roundedPercentage + '% watched';
        var eventLabel = videoTitle;

        if (!this.datalayerContainsPercentage(BRIGHTCOVE_VIDEO, eventAction, eventLabel)) {
          _tracking_utility.TrackingUtility.trackEvent({
            "eventCategory": _tracking_utility.TrackingUtility.getEventCategory(BRIGHTCOVE_VIDEO),
            "eventAction": eventAction,
            "eventLabel": eventLabel
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var videoPlayerParentStyle = {
        height: "100%",
        position: "absolute",
        top: 0,
        width: "100%",
        left: 0
      };
      var playlistId = this.props.fundVideo.mediaType === "Playlist" ? this.props.fundVideo.mediaId : null;
      var mediaId = this.props.fundVideo.mediaType === "Playlist" ? null : this.props.fundVideo.mediaId;
      var additionalVideoContainerWrapperClassNames = this.props.additionalVideoContainerWrapperClassNames || [];
      var videoContainerWrapperClassNames = ['col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12'].concat(_toConsumableArray(additionalVideoContainerWrapperClassNames)).join(" ");
      var additionalVideoContainerClassNames = this.props.additionalVideoContainerClassNames || [];
      var videoContainerClassNames = ['video-container'].concat(_toConsumableArray(additionalVideoContainerClassNames)).join(" ");
      return _react2.default.createElement(
        "div",
        { className: "", style: this.props.videoWrapperStyle || {} },
        _react2.default.createElement(
          "div",
          { className: videoContainerWrapperClassNames },
          _react2.default.createElement(
            "div",
            { "data-testid": "video-wrapper-test", style: { height: "0", paddingBottom: "56.25%", position: "relative" } },
            _react2.default.createElement(
              "div",
              { className: videoContainerClassNames, "data-testid": "video-container-test", style: videoPlayerParentStyle },
              _react2.default.createElement(_reactPlayerLoader2.default, {
                accountId: this.props.fundVideo.mediaPlayerId,
                playerId: "D624NUCYF",
                videoId: mediaId,
                playlistId: playlistId,
                onSuccess: function onSuccess(success) {
                  _this4.fundVideoPlayerRef = success.ref;
                  // eslint-disable-next-line no-underscore-dangle
                  var videoParent = success.ref.el_;
                  var videoElements = videoParent.children;
                  if (videoElements.length > 0) {
                    var videoPlayer = videoElements[0];
                    videoPlayer.addEventListener("timeupdate", function () {
                      return _this4.videoPlayerEvent(videoPlayer.currentTime, videoPlayer.duration, _this4.props.fundVideo.title);
                    });
                    videoPlayer.addEventListener("seeking", function () {
                      return _this4.videoPlayerEvent(videoPlayer.currentTime, videoPlayer.duration, _this4.props.fundVideo.title);
                    });
                  }
                },
                onFailure: function onFailure(err) {
                  // eslint-disable-next-line no-console
                  console.log('Failed to create brightcove Player', err);
                }
              })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 margin-top-10" },
          _react2.default.createElement(
            "div",
            { className: "padding-top-5" },
            _react2.default.createElement(
              "span",
              { "data-testid": "fund-video-description" },
              this.props.fundVideo.description
            )
          )
        )
      );
    }
  }]);

  return FundVideoComponent;
}(_react2.default.Component);

exports.default = FundVideoComponent;